<div class="container-box bulk-user-page">
  <!-- <app-breadcrumb [breadCrumbs]="breadCrumbs"></app-breadcrumb> -->
  <h1>Add multiple users</h1>
  <app-stepindicator [stepIndicators]="steps" [sessionName]="stepSessionName"></app-stepindicator>
  <router-outlet></router-outlet>
</div>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>
